import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    modalComponent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '480px',
        height: '378px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 2px 4px rgba(125, 149, 165, 0.5)',
        borderRadius: '10px'
    },
    cancelButton: {
        position: 'absolute',
        width: '109px',
        height: '40px',
        left: '178px',
        top: '309px',
        border: '1px solid #7D95A5',
        borderRadius: '50px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'medium',
        fontSize: '13px',
        lineHeight: '20px'
    },
    applyPaymentDisabled: {
        position: 'absolute',
        width: '137px',
        height: '40px',
        fontSize: '13px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'medium',
        lineHeight: '20px',
        left: '303px',
        top: '309px',
        backgroundColor: '#D8DDE2',
        borderRadius: '20px',
        border: 'none'
    },
    applyPaymentEnabled: {
        position: 'absolute',
        width: '137px',
        height: '40px',
        left: '303px',
        top: '309px',
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontSize: '13px',
        fontWeight: 'normal',
        lineHeight: '20px',
        backgroundColor: '#1BABE2',
        borderRadius: '20px',
        border: 'none',
        color: '#FFFFFF'
    }
});

export default useStyles;
